'use strict';

var createjs = createjs || {};

createjs.Transformable = class extends createjs.Container {

	static get defaultOptions() {
		return {
			move: true,
			rotate: true,
			scale: true,
		}
	}

	constructor(options) {
		super();

		this.debug = false;

		this.options = _.assign(createjs.Transformable.defaultOptions, options);

		// fractions:
		// move: how much finger movements transform
		// release: how much fade-out tweening after releasing fingers transform
		this.fraction = {base: 1, move: {}, release: {}};

		// numeric value to snap transformation by x
		this.snap = {};

		// freely transformable by property, overwrites borders if true
		this.free = {};

		// borders for specific values get stored here
		this.borders = {};

		// lock transformations regardless of other values
		this.lock = false;

		// bring active object to top
		this.bringToTop = true;

		this.transforms = {};

		// protected values

		// currently active fingers
		this._activeFingers = 0;

		// finger positions
		this._fingers = {};

		// stored movements, updated on every tick
		this._stack = [];

		this._changed = false;

		this.on('mousedown', this._mousedown);
		this.on('pressmove', this._pressmove);
		this.on('pressup', this._pressup);
		this.on('tick', this._enterFrame);

		_.bindAll(this, '_mousedown', '_pressmove', '_enterFrame', '_pressup', '_calculateActiveFingers', '_getEventPointerUID');

		if(this.options.move) this.addTransform('move', new createjs.MoveTransform(this));
		if(this.options.rotate) this.addTransform('rotate', new createjs.RotateTransform(this));
		if(this.options.scale) this.addTransform('scale', new createjs.ScaleTransform(this));
	}

	get STACK() {
		return 5
	};

	get START() {
		return 'start'
	};

	get UPDATE() {
		return 'update'
	};

	get COMPLETE() {
		return 'complete'
	};

	addTransform(type, transform){
		this.removeTransform(type);
		this.transforms[type] = transform;
	}

	removeTransform(type){
		if(this.transforms[type]){
			this.transforms[type].destroy();
			this.transforms[type] = null;
		}
	}

	_getEventPointerUID(id) {
		return _.isNumber(id) ? 'p' + id : _.uniqueId('p');
	}

	// store initial touchpoint-position
	_mousedown(evt) {
		if (!evt.pointerUID) evt.pointerUID = this._getEventPointerUID(evt.pointerID);

		this._fingers[evt.pointerUID] = {
			start: {x: evt.stageX, y: evt.stageY},
			current: {x: evt.stageX, y: evt.stageY},
			old: {x: evt.stageX, y: evt.stageY}
		};

		this._calculateActiveFingers();

		this.dispatchEvent(this.START);
	};

	// update touchpoint-positions
	_pressmove(evt) {
		if (!evt.pointerUID) evt.pointerUID = this._getEventPointerUID(evt.pointerID);
		this._fingers[evt.pointerUID].current.x = evt.stageX;
		this._fingers[evt.pointerUID].current.y = evt.stageY;
		this._calculateActiveFingers();

		this._changed = true;
	};

	// if positions changed (through pressmove): dispatch update-evt for later usage and keep track of old point-position
	// dispatch updates only on tick to save some performance
	_enterFrame() {
		if (this._changed) {
			this._changed = false;
			this.dispatchEvent(this.UPDATE);

			for (let pointerUID in this._fingers) {
				if (this._fingers[pointerUID].start) {
					this._fingers[pointerUID].old.x = this._fingers[pointerUID].current.x;
					this._fingers[pointerUID].old.y = this._fingers[pointerUID].current.y;
				}
			}
		}

		var stack = {};
		stack.x = this.x;
		stack.y = this.y;
		stack.scaleX = this.scaleX;
		stack.scaleY = this.scaleY;
		stack.rotation = this.rotation;

		// auto-stack container-properties regardless of use in subclasses
		if (this._stack.length > this.STACK) this._stack.shift();
		this._stack.push(stack);
	};

	// delete old and unused finger-positions
	_pressup(evt) {
		if (!evt.pointerUID) evt.pointerUID = this._getEventPointerUID(evt.pointerID);

		if (this._fingers[evt.pointerUID]) {
			delete(this._fingers[evt.pointerUID]);
		}

		this._calculateActiveFingers();

		if(this._activeFingers == 0) this.dispatchEvent(this.COMPLETE);
	};

	// calculates currently active fingers, can be used later in subclasses
	_calculateActiveFingers() {
		this._activeFingers = 0;

		for (let pointerUID in this._fingers) {
			if (this._fingers[pointerUID].start) {
				this._activeFingers++;
			}
		}
	}
};